import React from "react";
import _ from "lodash";
import Button from "Components/button/Button";
import WarningBanner from "Components/warningBanner/WarningBanner";
import PropTypes from "prop-types";
import withFormState from "Components/withFormState";
import { alertSuccess } from "Utils/alerts";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";
import { withRouter } from "react-router-dom";
import qs from "query-string";
import { Icon, file } from "Icons/index";
import cx from "classnames";
import s from "./ownershipCheckHTML.scss";

const initFormValues = {
  verification_email_address: "",
  possession_a_record: "",
};

class OwnershipCheckHTML extends React.Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.fileVerified && nextProps.fileVerified) {
      alertSuccess(t("alert.ownershipCheckSuccess"));
      this.props.history.push("/domains");
    }
  }

  generateFile() {
    this.props.generateFile(this.props.domainCode, this.props.aliasDomainCode);
  }

  verifyFile() {
    this.props.verifyFile(this.props.domainCode, this.props.aliasDomainCode);
  }

  render() {
    const {
      isVerifingFile,
      fileVerificationFailed,
      domainName,
      domainCode,
      isGeneratingFile,
      fileGenerated,
      url,
      resetOwnershipcheckStatus,
      isAlias,
      aliasDomainCode,
    } = this.props;

    let codeUrl = isAlias ? aliasDomainCode : domainCode;

    return (
      <div
        className={cx(s.ownershipCheckHTML, {
          [s.fileGenerated]: fileGenerated,
          [s.withErrors]: fileVerificationFailed,
        })}
      >
        {fileVerificationFailed && (
          <div className={s.warningMsg}>
            <WarningBanner msg={t("infoMsg.owCheckHTML.failed")} color="red" />
          </div>
        )}
        <div className={cx(s.introText, s.text)}>
          <TranslatedString>ownershipCheck.html.instruction.part1</TranslatedString>
        </div>

        {fileGenerated && (
          <div className={s.wrapStep}>
            <div className={s.step}>
              <div className={s.labelStep}>{t("ownershipCheck.html.instruction.step1.title")}</div>
              <a className={s.downloadFile} href={`${BASE_URL_PUBLIC_ASSETS}${url}`} download target="_blank">
                <Icon className={s.icon} svg={file} width="1rem" height="1rem" />

                <span>{t("action.download.verify.file")}</span>
              </a>
            </div>

            <div className={s.step}>
              <div className={s.labelStep}>{t("ownershipCheck.html.instruction.step2.title")}</div>
              <div className={s.text}>{t("ownershipCheck.html.instruction.step2.desc1")}</div>
              <a className={s.fileRoot} href={`http://${domainName}/${codeUrl.toLowerCase()}.html`} target="_blank">
                http://{domainName}/{codeUrl.toLowerCase()}.html
              </a>
              <div className={s.text}>{t("ownershipCheck.html.instruction.step2.desc2")}</div>
            </div>

            <div className={s.step}>
              <div className={s.labelStep}>3. Completa la verifica</div>
              <div className={s.text}>
                <TranslatedString>ownershipCheck.html.instruction.step3.desc1</TranslatedString>
              </div>
            </div>
          </div>
        )}

        <div className={s.footer}>
          {fileGenerated && (
            <Button color="outline" onClick={resetOwnershipcheckStatus} loading={isVerifingFile}>
              button.resetProcedure
            </Button>
          )}

          <div className={s.btnRight}>
            <Button color="text" onClick={() => this.props.resetAndGoBack()}>
              button.cancel
            </Button>
            {!fileGenerated && (
              <Button type="submit" loading={isGeneratingFile} onClick={this.generateFile.bind(this)}>
                button.HTMLfile
              </Button>
            )}
            {fileGenerated && (
              <Button onClick={this.verifyFile.bind(this)} loading={isVerifingFile}>
                button.verify
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withFormState(OwnershipCheckHTML, initFormValues));
